// extracted by mini-css-extract-plugin
module.exports = {"avatar":"DoctorAvatar-module__avatar___1FYZW","xsmall":"DoctorAvatar-module__xsmall___BveJI","small":"DoctorAvatar-module__small___1BbEy"};